import React from 'react';
import { Modal, Box, Typography, Button, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

export default function DeleteConfirmationModal({ open, onClose, onConfirm, title, message, loading = false }) {
    return (
        <Modal open={open} onClose={loading ? null : onClose}>
            <Box sx={{
                position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
                width: { xs: '90%', sm: 400 }, bgcolor: 'background.paper', borderRadius: 3, p: 4, boxShadow: 24,
                textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center'
            }}>
                <IconButton 
                    sx={{ position: 'absolute', top: 12, right: 12 }} 
                    onClick={onClose}
                    disabled={loading}
                >
                    <CloseIcon />
                </IconButton>

                <Box sx={{ 
                    width: 60, height: 60, borderRadius: '50%', bgcolor: '#fff4e5', 
                    display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 2 
                }}>
                    <WarningAmberIcon sx={{ fontSize: 35, color: '#ed6c02' }} />
                </Box>

                <Typography variant="h6" fontWeight="bold" gutterBottom>
                    {title || 'Are you sure?'}
                </Typography>
                
                <Typography variant="body1" color="text.secondary" mb={4}>
                    {message || 'This action cannot be undone.'}
                </Typography>

                <Box sx={{ display: 'flex', gap: 2, width: '100%' }}>
                    <Button 
                        fullWidth 
                        variant="outlined" 
                        onClick={onClose}
                        disabled={loading}
                    >
                        Cancel
                    </Button>
                    <Button 
                        fullWidth 
                        variant="contained" 
                        color="error"
                        onClick={onConfirm}
                        disabled={loading}
                    >
                        {loading ? 'Deleting...' : 'Delete'}
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
}
